/* eslint-disable import/prefer-default-export */
import { ApolloError } from '@apollo/client'

export const getErrorMessage = (error: ApolloError) =>
  (Array.isArray((error.networkError as any)?.result?.errors) &&
    (error.networkError as any)?.result?.errors[0].message) ||
  error.message
